import {useEffect} from 'react';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {LexicalEditor} from 'lexical';

type Props = {
    callback: (editor: LexicalEditor) => void;
};

export function ExposeEditorInstancePlugin({callback}: Props) {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        callback(editor);
    }, [callback, editor]);

    return null;
}
